export const capitalize = (string: any) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : undefined;
};
